import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IndividualLifeQuoteType, IndividualLifeApplicationType, IndividualLifePolicyType } from "IndividualLife/types";
import { fetchWithCSRFTokenForRequestObject } from "Utils/fetchWithCSRFToken";

import { appendAuthParams } from "Common/TokenAuth/Utils";

export const individualLifeApi = createApi({
  reducerPath: "individualLifeApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/v2/",
    fetchFn: fetchWithCSRFTokenForRequestObject,
  }),
  endpoints: (builder) => ({
    getIndividualLifeQuotes: builder.query<{ quotes: IndividualLifeQuoteType[] }, void>({
      query: () => ({
        url: appendAuthParams(`individual-life-quote`),
        method: "get",
      }),
      providesTags: ["IndividualLifeQuotes"],
    }),
    getIndividualLifeURL: builder.mutation<{ url: string }, IndividualLifeQuoteType>({
      query: (params) => {
        return {
          url: appendAuthParams(`individual-life-apply`),
          method: "post",
          body: { apply: params },
        };
      },
    }),
    getIndividualLifeApplication: builder.query<
      { individualLifeApplication: IndividualLifeApplicationType; individualLifePolicy: IndividualLifePolicyType; linkToCarrierApplication: string },
      void
    >({
      query: () => ({
        url: appendAuthParams(`individual-life-application`),
        method: "get",
      }),
      providesTags: ["IndividualLifeApplication"],
    }),
  }),
  tagTypes: ["IndividualLifeQuotes", "IndividualLifeApplication"],
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetIndividualLifeQuotesQuery, useGetIndividualLifeURLMutation, useGetIndividualLifeApplicationQuery } = individualLifeApi;
